import CountryLink from 'Components/common/CountryLink';
import React from 'react';
import flattenDeep from 'lodash/flattenDeep';
import last from 'lodash/last';
import unique from 'lodash/uniq';
const getAverage = (nums) => nums.reduce((a, b) => (a + b)) / nums.length;

const getRollingAvg = (array, lag = 7) => array
  .slice(lag - 1)
  .map((d, i) => array.slice(i, i + lag))
  .map((slice) => {
    if (slice.includes(null)) return null;
    const mean = getAverage(slice.map(d => d.count));
    return mean < 0 ? 0 : mean;
  });

const apDate = (date) => {
  const months = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
  return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
};

const getSpeedLanguage = (lastSpeed, maxSpeed, changeSpeed) => {
  if (lastSpeed === maxSpeed) return 'which is the fastest 7-day pace it has achieved so far';
  if (changeSpeed > -0.05) return 'which is about as fast a 7-day pace as it has achieved so far';
  return <span>which is about <strong>{Math.abs(Math.round(changeSpeed * 100))}% slower</strong> than its fastest 7-day pace</span>;
};

const SmartText = (props) => {
  const { country, vaccinations, priorityGroups } = props;
  const firstVaccinationDate = new Date(vaccinations.dailyDoses[0].date);
  const totalVaccinations = last(vaccinations.totalDoses).count;

  const rollingAvgs = getRollingAvg(vaccinations.dailyDoses);
  const maxSpeed = Math.max(...rollingAvgs);
  const lastSpeed = last(rollingAvgs);
  const changeSpeed = (lastSpeed - maxSpeed) / maxSpeed;

  const vaccines = unique(flattenDeep(priorityGroups.jurisdictions.map(j => j.phases.map(p => p.priorityGroups.map(g => g.availableVaccines.map(v => v.name))))));

  return (
    <div className='smarttext'>
      <p>
        <CountryLink country={country.isoAlpha2} />
        has administered at least <strong>{totalVaccinations.toLocaleString('en')}</strong> doses of COVID-19 vaccines. It is going at a rate of about <strong>{Math.round(last(rollingAvgs)).toLocaleString('en')}</strong> doses per day during the last week, {getSpeedLanguage(lastSpeed, maxSpeed, changeSpeed)}.
      </p>
      {vaccines.length > 0 && (
        <p>Vaccines offered:&nbsp;
          {vaccines
            .map(vac => (<strong key={vac}>{vac}</strong>))
            .reduce((combined, curr) => [combined, ', ', curr])}
        </p>
      )}

    </div>
  );
};

export default SmartText;
